module.exports = __webpack_public_path__ + "static/media/sopas.9df60b47.jpg";